import gsap from 'gsap/dist/gsap'
import { useLayoutEffect, useRef } from 'react'

import { Breakpoint, useCheckBreakpoint } from '~/utils'

import StrokeText from '~/shared/components/RewardsChest/StrokeText'
import ResponsiveImage from '~/components/Image/ResponsiveImage'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '35px' }]

const ChecklistRewardAnimationXp = ({ noOfXPs }: { noOfXPs: number }): React.ReactElement => {
  const xpRef = useRef(null)
  const isMobile = useCheckBreakpoint({ lt: Breakpoint.MD })

  const animationPath = isMobile
    ? 'M-64.013,10.183 C-30.886,4.305 7.326,-24.055 5.138,23.788'
    : 'M-79.688,10.475 C-46.588,4.603 7.326,-24.055 5.138,23.788'

  const percentPosition = isMobile ? -150 : -100

  useLayoutEffect(() => {
    gsap.set(xpRef.current, { xPercent: percentPosition, yPercent: percentPosition, transformOrigin: '50% 50%' })
    gsap.to(xpRef.current, {
      duration: 1,
      motionPath: {
        path: animationPath,
      },
    })

    gsap.to(xpRef.current, {
      duration: 2,
      delay: 2.2,
      opacity: 0,
    })
  }, [animationPath, percentPosition])

  return (
    <div
      className="flex flex-col items-center absolute top-1/2 left-1/2 transform translate-x-1/2 translate-y-1/2 z-10"
      ref={xpRef}
    >
      <StrokeText className="leading-4">+{noOfXPs}</StrokeText>
      <ResponsiveImage
        alt="math vault sitemap"
        height={482}
        imageWidths="35"
        mediaQuery={mediaQuery}
        srcKey="bootcamp/xp-icon.png"
        width={512}
      />
    </div>
  )
}

export default ChecklistRewardAnimationXp
